import { Application } from "@hotwired/stimulus"
import { controllers as bridgeControllers } from "@joemasilotti/bridge-components"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
document.documentElement.setAttribute("data-turbo-suppress-warning", true)
application.load(bridgeControllers)

export { application }
